import React from 'react';

const FeaturesTableRow = props => {
  const { rowStyles } = props;

  return (
    <div className="features-table-row" style={rowStyles}>
      {props.children}
    </div>
  );
};

export default FeaturesTableRow;
